import { render, staticRenderFns } from "./internstudentform.vue?vue&type=template&id=96a264aa&scoped=true&"
import script from "./internstudentform.vue?vue&type=script&lang=js&"
export * from "./internstudentform.vue?vue&type=script&lang=js&"
import style0 from "./internstudentform.vue?vue&type=style&index=0&id=96a264aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a264aa",
  null
  
)

export default component.exports